import { darkenToContrast } from "utils/accessibility";

// The design's signer palette. Most entries are too light to use as written:
// a signer color is a fill under white initials and a text and outline color
// on white, so it needs 4.5:1 (WCAG 1.4.3, 1.4.11). Read colors through
// SIGNER_COLORS or accessibleSignerColor, never this list.
const DESIGN_SIGNER_COLORS = [
  "#FF6B6B",
  "#FFB347",
  "#FFD700",
  "#00C49A",
  "#0088FE",
  "#A28EFF",
  "#FF69B4",
  "#FF7F50",
  "#40E0D0",
  "#6495ED",
  "#DC143C",
  "#2E8B57",
  "#4B0082", // was #20B2AA: darkened onto #40E0D0
  "#9932CC",
  "#880E4F", // was #FF8C00: darkened onto #FFB347
  "#8D6E63", // was #3CB371: darkened onto #2E8B57
  "#B22222",
  "#00CED1",
  "#9370DB",
  "#3E2723", // was #1E90FF: darkened onto #0088FE
];

/** The design palette, each entry darkened along its own hue to 4.6:1 on white. */
export const SIGNER_COLORS = DESIGN_SIGNER_COLORS.map((c) => darkenToContrast(c));

/**
 * Signer colors saved on requests created before the palette was darkened are
 * still the light design values; pass any stored color through this before
 * showing it. Falls back to the first palette color.
 */
export const accessibleSignerColor = (color?: string | null): string =>
  color ? darkenToContrast(color) : SIGNER_COLORS[0];
